import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed } from "vue";

type VariantType = typeof VARIANT_VALUES[number];


export default /*#__PURE__*/_defineComponent({
  __name: 'BeginnerTag',
  props: {
    variant: {},
    label: {}
  },
  setup(__props: any) {

const props = __props;

const VARIANT_VALUES = ["outlined", "contained"] as const;


const variant = ref(props.variant || "outlined");

const isOutlinedStyle = computed(() => variant.value === "outlined");
const tagClass = computed(() => (isOutlinedStyle.value ? "tag-outlined" : ""));

if (!VARIANT_VALUES.includes(variant.value)) {
  console.warn(
    `Invalid prop: variant should be one of ${VARIANT_VALUES.join(", ")}`
  );
}

return (_ctx: any,_cache: any) => {
  const _component_BeginnerMark = _resolveComponent("BeginnerMark")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tag-base", tagClass.value])
  }, [
    _createVNode(_component_BeginnerMark, { class: "beginner-mark" }),
    _createTextVNode(" " + _toDisplayString(_ctx.label), 1)
  ], 2))
}
}

})